import React, { InputHTMLAttributes } from 'react';
import { Field } from 'formik';
import { createUseStyles } from 'react-jss';
import Form from 'react-bootstrap/Form';
import clsx from 'clsx';

export interface FormikTextFieldProps
  extends InputHTMLAttributes<HTMLInputElement> {}

const FormikTextField: React.FC<FormikTextFieldProps> = ({
  name,
  className,
  ...others
}) => {
  const classes = useStyles();
  return (
    <Field name={name}>
      {({ field }: { field: any }) => (
        <Form.Control
          className={clsx(classes.input, className)}
          {...field}
          {...others}
        />
      )}
    </Field>
  );
};

const useStyles = createUseStyles({
  input: {
    backgroundColor: '#F5F5F5',
    padding: '25px 15px',
    border: '2px solid #dadada',
    borderRadius: '5px',
    fontWeight: 'bold',
    outline: 'none',
    '&:focus': {
      outline: 'none !important',
      boxShadow: 'none !important',
    },
    '&::placeholder': {
      color: '#bababa',
    },
  },
});

export default FormikTextField;
